import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=06ddbe1d&scoped=true"
import script from "./Tips.vue?vue&type=script&lang=ts"
export * from "./Tips.vue?vue&type=script&lang=ts"
import style0 from "./Tips.vue?vue&type=style&index=0&id=06ddbe1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ddbe1d",
  null
  
)

export default component.exports